export const PARTY = {
  child: "Luke's 10th Birthday",
  headline: 'Luke is 10!',
  date: 'Saturday, June 6, 2026',
  time: '12:00 PM – 2:30 PM',
  venue: 'Evergreen Hall',
  address: '9291 Corbould St, Chilliwack, BC V2P 4A6',
} as const;
